import * as actionType from "./action";

export function jwtReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.DECODE_JWT_SUCCESS:
      return { ...state, response };
    case actionType.DECODE_JWT_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
